import React from "react";

import styled from "styled-components";

//assets

//styles
import typographySizes from "styles/typographySizes.js";
import mediaQuery from "styles/mediaQuery.js";

//components
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";

const BodyParagraph = styled.p`

font-size: ${typographySizes.text.tekstSize2.size.desktop}rem;
line-height: ${typographySizes.text.tekstSize2.lineHeight};

`;

const Body = ({ children, className }) => {
  return (
    <BodyParagraph className={className}>
      <TextWithLineBreaks text={children} />
    </BodyParagraph>
  );
};

export default Body;
